import { render } from "./AboutDetail.vue?vue&type=template&id=391a32e5"
import script from "./AboutDetail.vue?vue&type=script&lang=js"
export * from "./AboutDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__